import {Component, Input, ElementRef, Renderer, AfterViewInit} from '@angular/core';
declare var DobryKantor: any;

@Component({
    selector: 'dk-user-menu',
    template: require('./user-menu.html'),
})

export class UserMenuComponent implements AfterViewInit {
    @Input() onClose: () => void;
    showHistoricalRates: boolean = true;
    showInfoPages: boolean = true;

    constructor(private elementRef: ElementRef, private renderer: Renderer) {
        this.showHistoricalRates = DobryKantor.params.cantor.version != 'doradcyfirmy';
        this.showInfoPages = DobryKantor.params.cantor.version != 'kantoronline' && DobryKantor.params.cantor.version != 'wymianywalut';
    }

    ngAfterViewInit() {
        this.renderer.listen(this.elementRef.nativeElement.children[0], 'touchend', (event) => {
            event.stopPropagation();
            this.onClose();
        });

        this.renderer.listen(this.elementRef.nativeElement.children[0], 'click', (event) => {
            event.stopPropagation();
            this.onClose();
        });

        this.renderer.listen(this.elementRef.nativeElement.children[0].children[0], 'touchend', (event) => {
            event.stopPropagation();
        });

        this.renderer.listen(this.elementRef.nativeElement.children[0].children[0], 'click', (event) => {
            event.stopPropagation();
        });
    }
}
